// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./../../caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-easy-js": () => import("./../../../src/pages/easy.js" /* webpackChunkName: "component---src-pages-easy-js" */),
  "component---src-pages-hard-js": () => import("./../../../src/pages/hard.js" /* webpackChunkName: "component---src-pages-hard-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-lol-js": () => import("./../../../src/pages/lol.js" /* webpackChunkName: "component---src-pages-lol-js" */)
}

